export default "__VITE_ASSET__rkeK3w0i__"